import { render, staticRenderFns } from "./SwitchPeopleRanking.vue?vue&type=template&id=52d736a5&scoped=true"
import script from "./SwitchPeopleRanking.vue?vue&type=script&lang=js"
export * from "./SwitchPeopleRanking.vue?vue&type=script&lang=js"
import style0 from "./SwitchPeopleRanking.vue?vue&type=style&index=0&id=52d736a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d736a5",
  null
  
)

export default component.exports